/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};

const timestampToTimes = (timestamp) => {
    if (timestamp != null) {
        let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-'
        let M =
            (date.getMonth() + 1 < 10 ?
                '0' + (date.getMonth() + 1) :
                date.getMonth() + 1) + '-'
        let D =
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

        return Y + M + D
    } else {
        return "   "
    }

};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
}

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
}

function parsePhonetic(phonetic) {
    if (phonetic) {
        try {
            var obj = JSON.parse(phonetic)
            if (Object.prototype.toString.call(obj) == '[object Array]') {
                var o = {}
                for (var i = 0; i < obj.length; i++) {
                    o[obj[i][0]] = obj[i][1]
                }
                return o
            } else {
                return obj;
            }
        } catch (e) {
            console.error(e)
        }
    }
    return null
}

function parseDefinition(definition) {
    if (!definition || definition.indexOf('.') < 0) {
        return definition
    }
    return definition.replace(/[a-z\-]+\./g, function (pos) {
        return '<i>' + pos + '</i>'
    })
}

function parseYong(yong, word, variantList) {
    yong.tags = yong.tag ? yong.tag.split('') : [];
    if (yong.word) {
        var words = yong.word.split(/\s*[\/,]\s*/)
        yong.exampleHtml = yong.example.split(/\s+/g).map((w) => {
            if (words.indexOf(w) > -1) {
                return '<strong>' + w + '</strong>'
            }
            return w
        }).join(' ')
    } else {
        var words = word.replace(/[^a-zA-Z\-_\/ ]/g, '').split(/\s*\/\s*/)
        if (variantList) {
            for (var i in variantList) {
                words.push(variantList[i].word.replace(/[^a-zA-Z\-_]/g, ''))
            }
        }
        var regword = new RegExp('\\b(' + words.join('|') + ')\\S*\\b', 'ig')

        yong.exampleHtml = yong.example.replace(regword, (w) => '<strong>' + w + '</strong>')
    }
    return yong
}


/**
 * 导出 
 **/
export {
    timestampToTime,
    timestampToTimes,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    parsePhonetic,
    parseDefinition,
    parseYong,
}


// WEBPACK FOOTER //
// ./src/utils/utils.js